import React, { useContext, useEffect, useState } from "react";
import PageHeader from "../util/PageHeader";
import {FEATURES, PAGE_HEADERS} from "../util/Constants";
import Navigation, { NavigationRoutes } from "../util/Navigation";
import {
    INDUCT_MANAGEMENT_DELIVERY_WINDOW_ROUTE,
    INDUCT_MANAGEMENT_FORCE_INDUCT_ROUTE,
    INDUCT_MANAGEMENT_MANAGE_CYCLE_ROUTE,
    INDUCT_MANAGEMENT_ROUTES
} from "../util/RouteConstants";
import Column from "@amzn/meridian/column";
import { CycleManagementContext } from "./context/CycleManagementContext";
import Loader from "../loader/Loader";
import { PermissionsContext } from "../permissions/PermissionsContext";
import { getFeaturesFromParent } from "../handler/ParentDataHandler";

const InductManagementDetail = ({ history, location }) => {
    const { cycleViewModel, cycleDispatch } = useContext(CycleManagementContext);
    const { isUserAuthorisedForForceInduct } = useContext(PermissionsContext);

    const [routesWhenPermissionsEnabled, setRoutesWhenPermissionsEnabled] = useState([]);
    const [isPermissionsFlagEnabled, setIsPermissionsFlagEnabled] = useState(false);

    useEffect(() => {
        cycleDispatch({
            type: 'LOAD_VIEW',
            data: { dispatcher: cycleDispatch }
        });
    }, []);

    useEffect(() => {
        const getPermissionsEnabledFlagStatus = async () => {
            const permissionsFeatureStatus = await getFeaturesFromParent([FEATURES.IS_INDUCT_MANAGEMENT_TAB_PERMISSIONS_ENABLED]);

            if (permissionsFeatureStatus.data && permissionsFeatureStatus.data.isInductManagementTabPermissionsEnabled) {
                setIsPermissionsFlagEnabled(true);

                const routesWithPermissions = [
                    INDUCT_MANAGEMENT_MANAGE_CYCLE_ROUTE,
                    ...(isUserAuthorisedForForceInduct ? [INDUCT_MANAGEMENT_FORCE_INDUCT_ROUTE] : []),
                    INDUCT_MANAGEMENT_DELIVERY_WINDOW_ROUTE
                ];
                setRoutesWhenPermissionsEnabled(routesWithPermissions);
            }
        };

        getPermissionsEnabledFlagStatus();
    }, [isUserAuthorisedForForceInduct]);

    if (cycleViewModel.loadingCycle || cycleViewModel.loadingNode) {
        return <Loader />;
    }

    return (
        <Column>
            <PageHeader {...PAGE_HEADERS.INDUCT_MANAGEMENT} />
            <Navigation
                routes={isPermissionsFlagEnabled ? routesWhenPermissionsEnabled : INDUCT_MANAGEMENT_ROUTES}
                location={location}
                history={history}
            />
            <NavigationRoutes
                routes={isPermissionsFlagEnabled ? routesWhenPermissionsEnabled : INDUCT_MANAGEMENT_ROUTES}
            />
        </Column>
    );
};

export default InductManagementDetail;



// WEBPACK FOOTER //
// ./src/components/inductmanagementv2/InductManagementDetail.js